import { enumUtil } from "../../../../utils/Enum";
import { useState, useEffect, useReducer } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest";
import NotificationHandler from "../../../../utils/NotificationHandler";
import Loader from "../../../shared/Loader/Loader";
import Table from "../../../Setup/Shared/Table";
import isNull from "../../../../utils/NullChecking";
import GridColumnHeader from "../../../Setup/Shared/GridColumnHeader";
import AmountFormatter from "../../../../utils/AmountFormatter";
import useSidebarSubMainTab from "../../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab";
import ClinicalSummary from "./ClinicalSummary/ClinicalSummary";
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import { FindFirstChild } from "../../../../utils/FindMenuOption";

const PatientsSummary = (props) => {
    let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    const [patientID, setPatientID] = useState('');
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const isHomeCareCheck = DropdownData.IsHomeCare
    const openSidebarSubMainTab = useSidebarSubMainTab();
    const [activeTab, setActiveTab] = useState('Financial');
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const API_URL = enumUtil.controller.PATIENT
    const API_Report = enumUtil.controller.Report
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let isViewAllowed = FindFirstChild('Patient', 'Financial Summary')?.ISView
    let isViewAllowedClinical = FindFirstChild('Patient', 'Clinical Summary')?.ISView


    if (PateintIDR && PateintIDR.data) {
        PateintIDR = PateintIDR.data.id;
    }
    let Summary_Modal = {
        // PracticeID: 113,
        PatientName: "",
        AccountNumber: "",
        Gender: "",
        DOB: null,
        Age: "",
        PrimaryInsurance: "",
        PatientBalance: "",
        PatientPortal: "",
        ProfilePicture: ""
    }
    let Insurance_Modal = {
        // PracticeID: 113,
        PrimaryInsured: "",
        PrimaryEligibility: "",
        PrimaryInsuredID: "",
        PrimaryCopay: '',
        PrimaryExpiryDate: "",
        PrimaryLastVisit: "",
        PrimaryInsurance: "",
        SecondaryInsured: "",
        SecondaryEligibility: "",
        SecondaryInsuredID: "",
        SecondaryCopay: '',
        SecondaryExpiryDate: "",
        SecondaryLastVisit: "",
        SecondaryInsurance: "",
    }
    const [mainSummaryModal, setmainSummaryModal] = useState(Summary_Modal);
    const [PatientInsurance, setPatientInsurance] = useState(Insurance_Modal);
    const [Aging, setAging] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [mainpicmodel, setMainpicmodel] = useState();
    const [genderClass, setGenderClass] = useState('');
    const [detailChecked, setDetailChecked] = useState(true);
    const [summaryChecked, setSummaryChecked] = useState(false);
    const [agingPatientData, setAgingPatientData] = useState([])
    const [isAccordionOpen, setIsAccordionOpen] = useState(true);
    const LoaduserImage = async (imgURL) => {
        // setIsLoading(true)
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": imgURL.ProfilePicture,
            }, "Download")
            console.log(response.type);

            if (response.type === 'application/jpg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                console.log('objectURL', objectURL);
                return objectURL

            }
            // setIsLoading(false)

        } catch (error) {
            // setIsLoading(false);
            throw error;
        }
    }
    // const LoadPatientSummary = async () => {
    //     if (PateintIDR != -1) {
    //         setIsLoading(true);
    //         try {
    //             const response = await ServerRequestProtected(API_URL + "/FindPatientSummary", 'post', {
    //                 "ID": PateintIDR + "",
    //                 "TableName": enumUtil.enumAPITableName.Patient
    //             });

    //             const basicInfo = response?.BasicInfo[0];

    //             if (basicInfo?.ProfilePicture) {
    //                 basicInfo.ProfilePicture = await LoaduserImage(basicInfo);

    //             }

    //             setmainSummaryModal(basicInfo);
    //             setPatientInsurance(response.PatientInsurance[0]);
    //             setAging(response.Aging[0]);
    //             if (response.BasicInfo[0].Gender === 'M') {
    //                 setGenderClass('za-male');
    //             } else if (response.BasicInfo[0].Gender === 'F') {
    //                 setGenderClass('za-female');
    //             }
    //             else if (response.BasicInfo[0].Gender === 'O') {
    //                 setGenderClass('za-others');
    //             }
    //             else {
    //                 setGenderClass('za-others');

    //             }
    //         } catch (error) {
    //             NotificationHandler(error.response?.data || 'Error loading patient summary', enumUtil.enumtoaster.error);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     } else {
    //         NotificationHandler('Please Fill Demographics First', enumUtil.enumtoaster.warning);
    //     }
    // };
    const LoadPatientSummary = async () => {
        if (PateintIDR != -1) {
            setIsLoading(true);
            try {
                const response = await ServerRequestProtected(API_URL + "/FindPatientSummary", 'post', {
                    "ID": PateintIDR + "",
                    "TableName": enumUtil.enumAPITableName.Patient
                });

                // const basicInfo = response?.BasicInfo[0];
                setmainSummaryModal(response?.BasicInfo[0]);

                // Set initial data without waiting for image
                // setmainSummaryModal({
                //     ...basicInfo,
                //     ProfilePicture: null, // or keep original if needed
                // });

                // Load image in background
                // if (basicInfo?.ProfilePicture) {
                //     LoaduserImage(basicInfo).then((imgUrl) => {
                //         setmainSummaryModal(prev => ({
                //             ...prev,
                //             ProfilePicture: imgUrl
                //         }));
                //     }).catch(err => {
                //         console.log("Image load error: ", err);
                //     });
                // }

                setPatientInsurance(response.PatientInsurance[0]);
                setAging(response.Aging[0]);

                const gender = response.BasicInfo[0].Gender;
                if (gender === 'M') setGenderClass('za-male');
                else if (gender === 'F') setGenderClass('za-female');
                else setGenderClass('za-others');

            } catch (error) {
                NotificationHandler(error.response?.data || 'Error loading patient summary', enumUtil.enumtoaster.error);
            } finally {
                setIsLoading(false);
            }
        } else {
            NotificationHandler('Please Fill Demographics First', enumUtil.enumtoaster.warning);
        }
    };
    useEffect(() => {
        setPatientID(PatientIDR);
        LoadPatientSummary()
    }, [])
    useEffect(() => {
        LoadDataAgingDetails()

        // if (detailChecked) {
        //     LoadDataAgingDetails()

        // }
        // else {
        //     LoadDataAgingSummary()

        // }
    }, [])
    // const LoadDataAgingSummary = () => {
    //     setAgingPatientData([])
    //     setIsLoading(true)
    //     ServerRequestProtected(API_Report + "/FindAgingSummary", 'post', {
    //         "TableName": enumUtil.enumAPITableName.PATIENTAGING,
    //         "SEARCHCRITERIA": {
    //             "PatientIDs": PateintIDR + "",
    //             // "PatientIDs": "",
    //             "ProcedureCode": "",
    //             "InsuranceID": "-1",
    //             "Age": "-1",
    //             "LocationID": "-1",
    //             "ProviderID": "-1",
    //             "GroupBy": "Patient",
    //             "DOSFrom": null,
    //             "DOSTo": null,
    //             "EntryDateFrom": null,
    //             "EntryDateTo": null,
    //             "SubmittedFrom": null,
    //             "SubmittedTo": null,
    //             "AgingBasedOn": "DOS",
    //             "AgingSlot": "5",
    //             "IsExcelExport": "1",
    //         },
    //         "PerPage": "20",
    //         "PageNo": "1",
    //     }).then((response) => {
    //         setIsLoading(false)
    //         setAgingPatientData(response.Rows)
    //         handleGridHeader({ defaultData: response.Rows })
    //     }).catch((error) => {
    //         setIsLoading(false)
    //     })
    // }
    const LoadDataAgingDetails = () => {
        setAgingPatientData([])
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/AgingByPatient", 'post', {
            "TableName": enumUtil.enumAPITableName.PATIENTAGING,
            "SEARCHCRITERIA": {
                "PatientIDs": PateintIDR + "",
                "AgingBasedOn": "DOS",
                "AgingSlot": "5",
                "Age": "-1",
                "PERAM": "Summary",
            },

        }).then((response) => {
            setIsLoading(false)
            setAgingPatientData(response.Rows)
            handleGridHeader({ defaultData: response.Rows })
        }).catch((error) => {
            setIsLoading(false)
            setAgingPatientData([])
        })
    }
    const handleNavigation = (row, key) => {

        if (key === 'Age0to30') {
            if (row?.Name === 'Patient Aging') {
                // let tabkey = `Reports-434-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-434-[{ "value": "Expiring", "display": "Expiring" }]')
            }
            else if (row?.Name === 'Insurance Aging') {
                // let tabkey = `Reports-432-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-432-[{ "value": "Expiring", "display": "Expiring" }]')

            }
        }
        else if (key === 'Age31to60') {
            if (row?.Name === 'Patient Aging') {
                // let tabkey = `Reports-434-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-434-[{ "value": "Expiring", "display": "Expiring" }]')

            }
            else if (row?.Name === 'Insurance Aging') {
                // let tabkey = `Reports-432-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-432-[{ "value": "Expiring", "display": "Expiring" }]')

            }
        }
        else if (key === 'Age61to90') {
            if (row?.Name === 'Patient Aging') {
                // let tabkey = `Reports-434-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-434-[{ "value": "Expiring", "display": "Expiring" }]')

            }
            else if (row?.Name === 'Insurance Aging') {
                // let tabkey = `Reports-432-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-432-[{ "value": "Expiring", "display": "Expiring" }]')

            }
        }
        else if (key === 'Age91to120') {
            if (row?.Name === 'Patient Aging') {
                // let tabkey = `Reports-434-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-434-[{ "value": "Expiring", "display": "Expiring" }]')

            }
            else if (row?.Name === 'Insurance Aging') {
                // let tabkey = `Reports-432-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-432-[{ "value": "Expiring", "display": "Expiring" }]')

            }
        }
        else if (key === 'Age120+') {
            if (row?.Name === 'Patient Aging') {
                // let tabkey = `Reports-434-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-434-[{ "value": "Expiring", "display": "Expiring" }]')

            }
            else if (row?.Name === 'Insurance Aging') {
                // let tabkey = `Reports-432-${JSON.stringify(row.Age0to30)}`
                // openSidebarSubMainTab(tabkey);
                openSidebarSubMainTab('Reports-432-[{ "value": "Expiring", "display": "Expiring" }]')

            }
        }

        // else if (key === "Age31to60") {
        //     if (searchParam.GroupBy === 'Insurance') {
        //         params.InsuranceID = row.ID;
        //     } else if (searchParam.GroupBy === 'Provider') {
        //         params.ProviderID = row.ID;
        //     } else if (searchParam.GroupBy === 'Location') {
        //         params.LocationID = row.ID;
        //     }
        //     let tabkeywritOff = `Reports-4310-${JSON.stringify(params)}`
        //     openSidebarSubMainTab(tabkeywritOff);
        // }
        //  else if (key === "Overpayment") {
        //     if (searchParam.GroupBy === 'Insurance') {
        //         params.InsuranceID = row.ID;
        //     } else if (searchParam.GroupBy === 'Provider') {
        //         params.ProviderID = row.ID;
        //     } else if (searchParam.GroupBy === 'Location') {
        //         params.LocationID = row.ID;
        //     }
        //     let tabkeyOverpayment = `Reports-439-${JSON.stringify(params)}`
        //     openSidebarSubMainTab(tabkeyOverpayment);
        // } else if (key === 'Claims') {
        //     let claimparam = { BillingStatus: 'Due Patient' }
        //     let tabkeyClaim = `Claims-71-${JSON.stringify(claimparam)}`
        //     openSidebarSubMainTab(tabkeyClaim);
        // } else if (key === "Paid") {
        //     if (searchParam.GroupBy === 'Insurance') {
        //         params.InsuranceID = row.ID;
        //     } else if (searchParam.GroupBy === 'Provider') {
        //         params.ProviderID = row.ID;
        //     } else if (searchParam.GroupBy === 'Location') {
        //         params.LocationID = row.ID;
        //     }
        //     let tabkeyCollectionDetail = `Reports-436-${JSON.stringify(params)}`
        //     openSidebarSubMainTab(tabkeyCollectionDetail);
        // } else if (key === "NotBilledAmount") {
        //     if (searchParam.GroupBy === 'Insurance') {
        //         params.InsuranceID = row.ID;
        //     } else if (searchParam.GroupBy === 'Provider') {
        //         params.ProviderID = row.ID;
        //     } else if (searchParam.GroupBy === 'Location') {
        //         params.LocationID = row.ID;
        //     }
        //     params['key'] = 7211
        //     let tabkeyCollectionDetail = `Submission-7211-${JSON.stringify(params)}`
        //     openSidebarSubMainTab(tabkeyCollectionDetail);
        // }
    }
    const DetailColumns = [
        // {
        //     key: 'Patient',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'Patient'} data={agingPatientData} setData={setAgingPatientData} />),
        //     width: 200,
        //     resizable: true,
        //     // renderCell: ({ row }) => {
        //     //     return (
        //     //         <>
        //     //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
        //     //                 <div className="copy_icon validation_message">
        //     //                     {row.Patient}
        //     //                 </div>
        //     //                 {row.Patient && <div className="icon_copy">
        //     //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Patient)}></i>
        //     //                     <p class="tool_tip xsm_text text-light">Copy</p>
        //     //                 </div>}
        //     //                 {copiedText[`${row.LineID}-${row.Patient}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
        //     //             </div>
        //     //         </>
        //     //     );
        //     // }
        // },
        // {
        //     key: 'Account #',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Account #'} sortIcon={true} type={'number'} colKey={'Account #'} data={agingPatientData} setData={setAgingPatientData} />),
        //     resizable: true,
        //     // renderCell: ({ row }) => {
        //     //     return (
        //     //         <>
        //     //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
        //     //                 <div className="copy_icon validation_message">
        //     //                     {row['Account #']}
        //     //                 </div>
        //     //                 {row['Account #'] && <div className="icon_copy">
        //     //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row['Account #'])}></i>
        //     //                     <p class="tool_tip xsm_text text-light">Copy</p>
        //     //                 </div>}
        //     //                 {copiedText[`${row.LineID}-${row['Account #']}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
        //     //             </div>
        //     //         </>
        //     //     );
        //     // }
        // },
        // ...(DropdownData?.IsHomeCare === 'true' ? [
        //     {
        //         key: 'MedicaidNo',
        //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //             iconName={'icon-card'} headerName={'Medicaid #'} sortIcon={true} type={'string'} colKey={'MedicaidNo'} data={agingPatientData} setData={setAgingPatientData} />),
        //         resizable: true
        //     },
        // ] : []),
        // {
        //     key: 'DOB',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'DOB'} sortIcon={true} type={'date'} colKey={'DOB'} data={agingPatientData} setData={setAgingPatientData} />),
        //     resizable: true,
        //     // renderCell: ({ row }) => {
        //     //     return (
        //     //         <>
        //     //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
        //     //                 <div className="copy_icon validation_message">
        //     //                     {row.DOB}
        //     //                 </div>
        //     //                 {row.DOB && <div className="icon_copy">
        //     //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.DOB)}></i>
        //     //                     <p class="tool_tip xsm_text text-light">Copy</p>
        //     //                 </div>}
        //     //                 {copiedText[`${row.LineID}-${row.DOB}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
        //     //             </div>
        //     //         </>
        //     //     );
        //     // }
        // },
        {
            key: 'Insurance',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'Insurance'} data={agingPatientData} setData={setAgingPatientData} />),
            width: 200,
            resizable: true,
            // renderCell: ({ row }) => {
            //     return (
            //         <>
            //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
            //                 <div className="copy_icon validation_message">
            //                     {row.Insurance}
            //                 </div>
            //                 {row.Insurance && <div className="icon_copy">
            //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Insurance)}></i>
            //                     <p class="tool_tip xsm_text text-light">Copy</p>
            //                 </div>}
            //                 {copiedText[`${row.LineID}-${row.Insurance}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            //             </div>
            //         </>
            //     );
            // }

        },
        {
            key: 'MemberID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Subscriber ID'} sortIcon={true} type={'number'} colKey={'MemberID'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
        },
        {
            key: 'ClaimID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Claim #'} sortIcon={true} type={'number'} colKey={'ClaimID'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            // renderCell({ row }) {
            //     let data = {
            //         name: 'Claims',
            //         data: {
            //             id: row.ClaimID,
            //             name: row.Patient,
            //             VisitType: row.ClaimType,
            //             ClaimRecord: claimRecord,
            //         }
            //     };
            //     return (
            //         <>
            //             <div className='slim_link' onClick={() => handleOpenNewBrowserTab(data)}>{row.ClaimID} </div>
            //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
            //                 <div className="copy_icon validation_message">
            //                 </div>
            //                 {row.ClaimID && <div className="icon_copy">
            //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.ClaimID)}></i>
            //                     <p class="tool_tip xsm_text text-light">Copy</p>
            //                 </div>}
            //                 {copiedText[`${row.LineID}-${row.ClaimID}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            //             </div>

            //         </>
            //     );
            // },
        },

        {
            key: 'Submitted',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Submitted'} sortIcon={true} type={'date'} colKey={'Submitted'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
        },
        {
            key: 'DOS',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'DOS'} sortIcon={true} type={'date'} colKey={'DOS'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
        },
        {
            key: 'Billed',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Billed'} sortIcon={true} type={'string'} colKey={'Billed'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Billed} /></>) },
        },
        {
            key: 'Allowed',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Allowed'} sortIcon={true} type={'string'} colKey={'Allowed'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Allowed} /></>) },
        },
        {
            key: 'InsPaid',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Ins Paid'} sortIcon={true} type={'string'} colKey={'InsPaid'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.InsPaid} /></>) },

        },
        {
            key: 'PatBal',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Pat Bal'} sortIcon={true} type={'string'} colKey={'PatBal'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.PatBal} /></>) },

        },
        {
            key: 'PatPaid',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Pat Paid'} sortIcon={true} type={'string'} colKey={'PatPaid'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.PatPaid} /></>) },

        },
        {
            key: 'ClaimAge',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Claim Age'} sortIcon={true} type={'string'} colKey={'ClaimAge'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
        },
        {
            key: 'Age0to30',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'0-30'} sortIcon={true} type={'string'} colKey={'Age0to30'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Age0to30} /></>) },
            resizable: true,
        },
        {
            key: 'Age31to60',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'31-60'} sortIcon={true} type={'string'} colKey={'Age31to60'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Age31to60} /></>) },
            resizable: true,
        },
        {
            key: 'Age61to90',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'61-90'} sortIcon={true} type={'string'} colKey={'Age61to90'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Age61to90} /></>) },
            resizable: true,
        },
        {
            key: 'Age90to120',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'91-120'} sortIcon={true} type={'string'} colKey={'Age90to120'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Age90to120} /></>) },
            resizable: true,
        },
        {
            key: 'Age120',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'120 +'} sortIcon={true} type={'string'} colKey={'Age120'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Age120} /></>) },
            resizable: true,
        },
        {
            key: 'Provider',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'Provider'} data={agingPatientData} setData={setAgingPatientData} />),
            width: 200,
            resizable: true,
            // renderCell: ({ row }) => {
            //     return (
            //         <>
            //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
            //                 <div className="copy_icon validation_message">
            //                     {row.Provider}
            //                 </div>
            //                 {row.Provider && <div className="icon_copy">
            //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Provider)}></i>
            //                     <p class="tool_tip xsm_text text-light">Copy</p>
            //                 </div>}
            //                 {copiedText[`${row.LineID}-${row.Provider}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            //             </div>
            //         </>
            //     );
            // }

        },
        {
            key: 'Location',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Location'} sortIcon={true} type={'string'} colKey={'Location'} data={agingPatientData} setData={setAgingPatientData} />),
            width: 200,
            resizable: true,
            // renderCell: ({ row }) => {
            //     return (
            //         <>
            //             <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
            //                 <div className="copy_icon validation_message">
            //                     {row.Location}
            //                 </div>
            //                 {row.Location && <div className="icon_copy">
            //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Location)}></i>
            //                     <p class="tool_tip xsm_text text-light">Copy</p>
            //                 </div>}
            //                 {copiedText[`${row.LineID}-${row.Location}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            //             </div>
            //         </>
            //     );
            // }

        },
    ];
    const SummaryColumns = [


        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'Name'} data={agingPatientData} setData={setAgingPatientData} />),
            width: 200,
            resizable: true,
        },
        {
            key: 'TotalAge0to30',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'0-30'} sortIcon={true} type={'string'} colKey={'TotalAge0to30'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <div className="slim_link_hover" onClick={() => handleNavigation(row, 'Age0to30')}>
                        <AmountFormatter amount={row.TotalAge0to30} />
                    </div>)
            },
        },
        {
            key: 'TotalAge31to60',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'31-60'} sortIcon={true} type={'string'} colKey={'TotalAge31to60'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => {
                return (
                    <div className="slim_link_hover" onClick={() => handleNavigation(row, 'Age31to60')}>
                        <AmountFormatter amount={row.TotalAge31to60} />
                    </div>)
            },
            resizable: true,
        },
        {
            key: 'TotalAge61to90',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'61-90'} sortIcon={true} type={'string'} colKey={'TotalAge61to90'} data={agingPatientData} setData={setAgingPatientData} />),
            resizable: true,

            renderCell: ({ row }) => {
                return (
                    <div className="slim_link_hover" onClick={() => handleNavigation(row, 'Age61to90')}>
                        <AmountFormatter amount={row.TotalAge61to90} />
                    </div>)
            },
        },
        {
            key: 'TotalAge90to120',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'91-120'} sortIcon={true} type={'string'} colKey={'TotalAge90to120'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => {
                return (
                    <div className="slim_link_hover" onClick={() => handleNavigation(row, 'Age91to120')}>
                        <AmountFormatter amount={row.TotalAge90to120} />
                    </div>)
            },
            resizable: true,
        },
        {
            key: 'TotalAge120',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'120+'} sortIcon={true} type={'string'} colKey={'TotalAge120'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => {
                return (
                    <div className="slim_link_hover" onClick={() => handleNavigation(row, 'Age120+')}>
                        <AmountFormatter amount={row.TotalAge120} />
                    </div>)
            },
            resizable: true,
        },
        {
            key: 'SumTotalAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Total'} sortIcon={true} type={'string'} colKey={'SumTotalAmount'} data={agingPatientData} setData={setAgingPatientData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.SumTotalAmount} /></>) },
            resizable: true,
        },
    ];
    useEffect(() => {
        console.log("prop reload Summary", props.Reload)
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 211) {
                    LoadPatientSummary()

                }
            })
            if (data.length === 0) {
                LoadPatientSummary()
            }
        }
    }, [props.Reload])
    const getInitials = (name) => {
        const nameArray = name.split(' ');
        if (nameArray.length >= 2) {
            return  nameArray[1][0] +nameArray[0][0] ;
        } else if (nameArray.length === 1) {
            return nameArray[0][0];
        }
        return '';
    };
    const userInitials = getInitials(mainSummaryModal.PatientName)
    const handleClaimsChange = (event) => {
        setDetailChecked(event.target.checked);
        if (event.target.checked) {
            setSummaryChecked(false);
        }
    };
    const handleServiceLinesChange = (event) => {
        setSummaryChecked(event.target.checked);
        if (event.target.checked) {
            setDetailChecked(false);
        }
    };
    const handleAccordionToggle = (event) => {
        if (event.target.closest('.MuiAccordionSummary-expandIconWrapper')) {
            setIsAccordionOpen(!isAccordionOpen);
        }
    };
    const [cliniacalactiveData, setClinicalActiveData] = useState(false);
    const handleActive = (tab) => {
        if (tab === 'Clinical') {
            setClinicalActiveData(true);
            setActiveTab(tab)
        } else {
            setClinicalActiveData(false);
            setActiveTab(tab)

        }
    }

    
    return (
        <>
            <div className="br-bottom-1 br-clr">
                {isLoading ? <Loader /> : null}

                <div className="m-0 row column-gap-30 financial_tab bg-white">
                    <div className="col-md-3 p-0 pt-1">
                        {/* <div className="pt-2 pb-3">
                            <div className="img-container s-175 h-120 circle m-auto">
                             <img src={mainSummaryModal.ProfilePicture || userInitials} alt="" />
                            </div>
                            <div className="img-container s-175 h-120 circle m-auto">
                                {mainpicmodel ? (
                                    <img src={mainpicmodel} alt="" />

                                ) : (
                                    <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${genderClass}`}><h1 className="justify-content-center">{userInitials}</h1></p>)}
                            </div>
                            <div className="text-center mt-3">
                                <p className="heading">{mainSummaryModal.PatientName}</p>
                                <div className="gender m-auto mt-1">ID: {mainSummaryModal?.AccountNumber}</div>
                            </div>
                            <div className="mt-4 ">
                                <p className="text text-muted font-sb fs-16 mb-1">DOB: {mainSummaryModal.DOB}</p>
                                <p className="text text-muted font-sb fs-16">Age: {mainSummaryModal.Age}</p>
                                <p className="heading info">Basic Information</p>
                                <p className="text mt-2" >{mainSummaryModal.Gender === 'F' ? 'Female' : mainSummaryModal.Gender === 'M' ? 'Male' : mainSummaryModal.Gender === 'O' ? 'Other' : 'N/A '}</p>
                                <p className="text mt-2  ">{mainSummaryModal.DOB}</p>
                                <p className="heading info mt-4">Contact Information</p>
                                <p className="text mt-2 validation_message " title={mainSummaryModal.Email}>{mainSummaryModal.Email ? mainSummaryModal.Email : <span className="text-danger ">Email Not Found!</span>}</p>
                                <p className="text mt-2" >{mainSummaryModal.HomePhoneNumber ? mainSummaryModal.HomePhoneNumber : <span className="text-danger">Phone # Not Found!</span>}</p>
                                <p className="text mt-2 " >{mainSummaryModal.MobileNumber ? mainSummaryModal.MobileNumber : <span className="text-danger "> Mobile # Not Found!</span>}</p>
                                <p className="heading info mt-4">Provider </p>
                                <p className="text mt-2" >{mainSummaryModal.ProviderName ? mainSummaryModal.ProviderName : <span className="text-danger ">N/A</span>}</p>
                                <p className="heading info mt-2">Last Appointment Date </p>
                                <p className="text mt-2" >{mainSummaryModal.LastAppointment ? mainSummaryModal.LastAppointment : <span className="text-danger ">N/A</span>}</p>
                                <p className="heading info mt-2">Next Appointment Date </p>
                                <p className="text mt-2" >{mainSummaryModal.NextAppointment ? mainSummaryModal.NextAppointment : <span className="text-danger ">N/A</span>}</p>
                            </div>
                            <div className="mt-4">
                                <p className="text text-muted font-sb fs-16 mb-1">Pri Ins: {mainSummaryModal.PrimaryInsurance}</p>
                                <p className="text text-muted font-sb fs-16 mb-1">Patient Balance: ${mainSummaryModal.PatientBalance}</p>
                                <p className="text text-muted font-sb fs-16">Patient Portal: {mainSummaryModal.PatientPortal}</p>
                            </div>
                            <div className="mt-4">
                                <p className="text text-muted font-sb fs-16 mb-1">BMI: 28.09</p>
                                <p className="text text-muted font-sb fs-16 mb-1">BP: 145/88</p>
                                <p className="text text-muted font-sb fs-16">Next Scheduled Appt:</p>
                            </div>
                        </div> */}
                        <span className="patient_tabs ms-2 d-flex justify-content-between align-items-center gap-20 w-fit-content">
                            {isHomeCareCheck === "true" ? null :
                                <>
                                    <p className={`${activeTab === 'Clinical' ? 'heading fs-14' : 'text fs-14 ar-light-color'} cursor-pointer`} onClick={() => handleActive('Clinical')}>Clinical</p>
                                    <div className="line-sprater"></div>
                                </>
                            }
                            <p className={`${activeTab === 'Financial' ? 'heading fs-14' : 'text fs-14 ar-light-color'} cursor-pointer`} onClick={() => handleActive('Financial')}> Financial</p>
                        </span>
                        <div className="p-2 br-bottom-1px za-light mb-10 d-flex flex-column gap-1 ">
                            <div className="d-flex align-items-center mb-1 gap-2 pat-detail">
                                <div className="">
                                    <div className="img-container s-40 circle">
                                        {mainSummaryModal?.ProfilePicture ? (
                                            <img src={mainSummaryModal?.ProfilePicture} alt="Profile" className="w-100 h-100 circle" />
                                        ) : (
                                            <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${genderClass}`}>
                                                {userInitials}
                                            </p>
                                        )}
                                    </div>

                                    {/* <div className="img-container s-45 circle">
                                        <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male">JS</p>
                                    </div> */}
                                </div>

                                <div className="col-md-10">
                                    <div className="d-flex justify-content-between align-items-center gap-2">
                                        <p className="heading fs-13 ar-dark-color w-100 validation_message text-nowrap">{mainSummaryModal?.PatientName}</p>
                                        <p className={`Paid pill ${mainSummaryModal?.PatientStatus === 'False' ? 'Denied' : ''}`} >{mainSummaryModal?.PatientStatus === 'False' ? "InActive" : "Active"}</p>
                                    </div>
                                    {/* <p className="heading fs-12">
                                        {mainSummaryModal && mainSummaryModal.DOB ? (
                                            <>
                                                {mainSummaryModal.DOB}
                                                {mainSummaryModal.Age ? ` (${mainSummaryModal.Age})` : ''}
                                                {mainSummaryModal.Gender === "M"
                                                    ? ' Male'
                                                    : mainSummaryModal.Gender === "F"
                                                        ? ' Female'
                                                        : mainSummaryModal.Gender === "O"
                                                            ? ' Other'
                                                            : mainSummaryModal.Gender === "Unknown"
                                                                ? ' Unknown'
                                                                : mainSummaryModal.Gender === "Patient de"
                                                                    ? ' Patient de'
                                                                    : ''}
                                            </>
                                        ) : null}
                                    </p> */}

                                    <div className="d-flex align-items-center gap-6">
                                        <p className="heading font-m ar-light-color">{mainSummaryModal?.DOB}</p>
                                        <p className="heading font-m ar-light-color"> {mainSummaryModal.Age ? ` ${mainSummaryModal.Age}` : ''} </p>
                                        <p className="heading font-m ar-light-color">{mainSummaryModal?.Gender === "M" ? 'Male' : mainSummaryModal?.Gender === "F" ? 'Female' : mainSummaryModal?.Gender === "O" ? 'Other' : mainSummaryModal?.Gender === "Unknown" ? 'Unknown' : mainSummaryModal?.Gender === "Patient de" ? 'Patient de' : ''}</p>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex justify-content-between align-items-center'>
                                <p className='text font-m ar-light-color'>Account #</p>
                                <p className='text font-m'>{mainSummaryModal?.AccountNumber}</p>
                            </div>
                            {/* <div className='d-flex justify-content-between align-items-center'>
                                <p className='text font-m ar-light-color'>Cell Phone</p>
                                <p className='text font-m'>
                                    {mainSummaryModal?.MobileNumber
                                        ? FormatPhoneNumber(mainSummaryModal.MobileNumber)
                                        : 'Not Recorded'}
                                </p>
                            </div> */}
                            <div className='d-flex justify-content-between align-items-center gap-2'>
                                <p className='text font-m ar-light-color'>Payer</p>
                                <p className='text font-m singleLine-ellispis' title={mainSummaryModal?.Insurance}>{mainSummaryModal?.Insurance || 'Not Assigned'}</p>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <p className='text font-m ar-light-color'>Last Visit</p>
                                <p className='text font-m'>{mainSummaryModal?.LastVisit === "" ? 'No Previous Record' : mainSummaryModal?.LastVisit}</p>
                            </div>
                        </div>

                        <div className="px-2 sidebar-scroll">

                            <div className="mb-2">
                                <p className="heading fs-13 mb-1">Contact Information</p>

                                <div className="Card_info d-flex flex-column row-gap-8 mb-10">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <p className='text font-m'>Email</p>
                                        <p className='text'>{mainSummaryModal?.Email}</p>
                                    </div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <p className='text font-m'>Cell Phone</p>
                                        <p className='text'>
                                            {mainSummaryModal?.MobileNumber
                                                ? FormatPhoneNumber(mainSummaryModal.MobileNumber)
                                                : ''}
                                        </p>
                                    </div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <p className='text font-m'>Home Phone</p>
                                        <p className='text '>
                                            {mainSummaryModal?.HomePhoneNumber
                                                ? FormatPhoneNumber(mainSummaryModal.HomePhoneNumber)
                                                : ''}
                                        </p>
                                    </div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <p className='text font-m'>Work Phone</p>
                                        <p className='text '>
                                            {mainSummaryModal?.WorkNumber
                                                ? FormatPhoneNumber(mainSummaryModal.WorkNumber)
                                                : ''}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2">
                                <p className="heading fs-13 mb-1">Address Infromation</p>
                                <div className="Card_info">
                                    <p className="text font-m fs-12">{mainSummaryModal?.PatientAddress} </p>
                                </div>
                            </div>

                            <div className="mb-2">
                                <p className="heading fs-13 mb-1">Patient Preferences</p>
                                <div className="Card_info">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <p className="text font-m">Preferred Language</p>
                                        <p className="text ">{mainSummaryModal?.PreferredLanguage}</p>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center gap-2">
                                        <p className="text font-m">Preferred Communication</p>
                                        <p className="text">{mainSummaryModal?.PreferredCommunication}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6 br-right-1 br-clr">
                        <div className="pt-2 pb-3">
                            <div className="row row-half mb-2">
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Gender</label>
                                        <select className="form-control">
                                            <option value="">Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Maritial Status</label>
                                        <select className="form-control">
                                            <option value="">Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>DOB</label>
                                        <input className="form-control" type="date" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>SSN</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Gender Identity</label>
                                        <select className="form-control">
                                            <option value="">Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Sexual Orientation</label>
                                        <select className="form-control">
                                            <option value="">Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Alt Patient Name</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Prefix</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Suffix</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="row row-half">
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Previous Name</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Preferred Language</label>
                                        <select className="form-control">
                                            <option>Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Language Proficiency</label>
                                        <select className="form-control">
                                            <option>Option</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-half">

                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Language Ability</label>
                                        <select className="form-control">
                                            <option>Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Religion</label>
                                        <select className="form-control">
                                            <option>Option</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Name Type Code</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="row row-half">
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Birth Order</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group input">
                                        <label>Status</label>
                                        <input className="form-control" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div className="form-check ">
                                <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                <label className="form-check-label" htmlFor="inlineCheckbox1">Is item Defective</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="pt-2 pb-3">
                            <div className="form-group input">
                                <label>Race</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className="form-group input">
                                <label>Ethnicity</label>
                                <input type="text" className="form-control" />
                            </div>
                        </div>
                    </div> */}
                    <div className="col-md-9 p-0 right_section pt-1">
                        {activeTab === "Financial" && isViewAllowed ?
                            <>
                                <div className="d-flex ps-1">
                                    <div class="col-md-5 primary pb-1">
                                        <div class="cards_header d-flex justify-content-between px-2 py-1">
                                            <p class="heading">Primary</p>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Insured:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryInsured) ? PatientInsurance.PrimaryInsured : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Eligibility:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryEligibility) ? PatientInsurance.PrimaryEligibility : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Insured ID:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryInsuredID) ? PatientInsurance.PrimaryInsuredID : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Co-pay:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryCopay) ? '$' + PatientInsurance.PrimaryCopay : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Expiry Date:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryExpiryDate) ? PatientInsurance.PrimaryExpiryDate : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Last Visit:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryLastVisit) ? PatientInsurance.PrimaryLastVisit : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="d-flex align-items-baseline gap-4 w-100">
                                                <div class="col-md-2">
                                                    <p class="heading">Insurance: </p>
                                                </div>
                                                <div class="col-md-10 ins_text">
                                                    <p class="text">{!isNull(PatientInsurance.PrimaryInsurance) ? PatientInsurance.PrimaryInsurance : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-5 primary Secondary pb-1">
                                        <div class="cards_header d-flex justify-content-between px-2 py-1">
                                            <p class="heading">Secondary</p>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Insured:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryInsured) ? PatientInsurance.SecondaryInsured : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Eligibility:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryEligibility) ? PatientInsurance.SecondaryEligibility : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Insured ID:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryInsuredID) ? PatientInsurance.SecondaryInsuredID : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Copay:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryCopay) ? '$' + PatientInsurance.SecondaryCopay : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Expiry Date:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryExpiryDate) ? PatientInsurance.SecondaryExpiryDate : 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-baseline gap-2">
                                                <div class="col-md-5">
                                                    <p class="heading">Last Visit:</p>
                                                </div>
                                                <div class="col-md-7">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryLastVisit) ? PatientInsurance.SecondaryLastVisit : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="d-flex align-items-baseline gap-4 w-100">
                                                <div class="col-md-2">
                                                    <p class="heading">Insurance: </p>
                                                </div>
                                                <div class="col-md-10 ins_text">
                                                    <p class="text">{!isNull(PatientInsurance.SecondaryInsurance) ? PatientInsurance.SecondaryInsurance : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 primary tertiary pb-1">
                                        <div class="cards_header d-flex justify-content-between px-2 py-1">
                                            <p class="heading">Patient Balance</p>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-12 d-flex align-items-baseline gap-2">
                                                <div class="col-md-7">
                                                    <p class="heading">Pat Balance:</p>
                                                </div>
                                                <div class="col-md-5">
                                                    <p class="text">{!isNull(mainSummaryModal.PatientBalance) ? mainSummaryModal.PatientBalance : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-12 d-flex flex-column align-items-baseline">
                                                <div class="col-md-7">
                                                    <p class="heading">Unapplied Pat Pay:</p>
                                                </div>
                                                <div class="col-md-5">
                                                    {/* <p class="text">{!isNull(PatientInsurance.SecondaryInsuredID) ? PatientInsurance.SecondaryInsuredID : 'N/A'}</p> */}
                                                    <p class="text">{!isNull(mainSummaryModal.UnAppliedPatPayment) ? mainSummaryModal.UnAppliedPatPayment : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex px-2 mt-2">
                                            <div className="col-md-12 d-flex flex-column align-items-baseline">
                                                <div>
                                                    <p class="heading">Last Statement:</p>
                                                </div>
                                                <div class="col-md-5">
                                                    {/* <p class="text">{!isNull(PatientInsurance.SecondaryInsured) ? PatientInsurance.SecondaryInsured : 'N/A'}</p> */}
                                                    <p class="text">{!isNull(mainSummaryModal.LastStatement) ? mainSummaryModal.LastStatement : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="app-acordian ar-accordian-content za-financial_summary ms-1">

                                    <Accordion expanded={isAccordionOpen}>

                                        <AccordionSummary
                                            className="flex-row-reverse"
                                            id="prac2-header"
                                            // className="flex-row-reverse"
                                            aria-controls="prac2-content"
                                            expandIcon={<ExpandMoreIcon />}
                                            onClick={handleAccordionToggle}
                                        >
                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                <p className="heading">Aging</p>

                                                {/* <div className='d-flex align-items-center gap-15'>
                                            <div className="ar_radio-btn d-flex align-items-center gap-2">
                                                <input type="radio"
                                                    id="DetailCheck"
                                                    name="DetailCheck"
                                                    autoComplete="off"
                                                    checked={detailChecked}
                                                    onChange={handleClaimsChange}
                                                    onClick={handleClaimsChange}
                                                />
                                                <p className="text ar-orange-text fs-13">Aging Detail</p>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-2">
                                                <input type="radio"
                                                    id="SummaryCheck"
                                                    name="SummaryCheck"
                                                    autoComplete="off"
                                                    checked={summaryChecked}
                                                    onChange={handleServiceLinesChange}
                                                    onClick={handleServiceLinesChange}
                                                />
                                                <p className="text ar-orange-text fs-13">Aging Summary</p>
                                            </div>
                                        </div> */}


                                            </div>

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="position-relative">
                                                <Table
                                                    // key={detailChecked ? DetailColumns : SummaryColumns}
                                                    // columns={detailChecked ? DetailColumns : SummaryColumns}
                                                    columns={SummaryColumns}
                                                    rows={agingPatientData}
                                                    height="100%"
                                                    dynamicClass="fill-grid DataGrid-Table hk-exp-table all_patient BorderLess-Grid"
                                                    rowHeight={25}
                                                    hidePagination={true}
                                                    Key={21}
                                                    Name={"PatientSearch"}
                                                    hideColClass={'hide'}
                                                />
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </> : null}
                        {activeTab === "Clinical" && isViewAllowedClinical ? <ClinicalSummary {...props} patientID={patientID} /> : null}
                    </div>
                </div>
            </div>
        </>
    )
}
export default PatientsSummary